import React from 'react'
import { DataTool } from '@ztechapps/webui.data-tools'
import { useInvoiceListContext } from './Context'
import { StorageKeys } from '../../../config/StorageKeys'
import { fields } from './constants/Fields'

export const Toolbox = () => {
  const { invoiceList } = useInvoiceListContext()

  return (
    <DataTool
      searchPlaceHolder={'Search invoices'}
      filterCategory={StorageKeys.invoiceFilterCategory}
      fields={fields}
      {...invoiceList}
    />
  )
}
